export const LINE_OFFICIAL_URL = 'https://lin.ee/Y2DbsHW';
export const IG_URL = 'https://www.instagram.com/peninsoundla/';
export const EMAIL_URL = 'info@launcher.com.tw';

export const LINK_ABOUTLOVE_ALL = 'https://www.launcher.com.tw/pages/peninsoundla-aboutlove';
export const LINK_ABOUTLOVE_DIGITAL = 'https://www.launcher.com.tw/products/aboutlove-digital';
export const LINK_ABOUTLOVE_TOUR = 'https://www.launcher.com.tw/products/aboutlove-tour';
export const LINK_ABOUTDESTINY = 'https://line.me/R/ti/p/@peninsoundla';
export const LINK_ABOUTRESONACE = 'https://www.launcher.com.tw/products/aboutresonance';

export const KKDAY_URL = 'https://www.kkday.com/zh-tw/product/703756';

export const linksMap = {
    LINE_OFFICIAL_URL,
    IG_URL,
    EMAIL_URL,
    LINK_ABOUTLOVE_ALL,
    LINK_ABOUTLOVE_DIGITAL,
    LINK_ABOUTLOVE_TOUR,
    LINK_ABOUTDESTINY,
    LINK_ABOUTRESONACE,
    KKDAY_URL,
};
